'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bindActions = undefined;

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

var _handlers = require('./handlers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var bindActions = exports.bindActions = function bindActions() {
  // $(document).off('click', '[data-add-to-cart]', handleAddToCart); // don't add multiple handlers
  $(document).on('click', _Dom2.default.addToCart, function () {
    // console.log('==== ATC CLICKED ');

    (0, _handlers.handleAddToCart)();
  });
};